var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',_vm._b({attrs:{"alt":_vm.alt,"src":_vm.themeLogoPath}},'b-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }